<template>
  <section id="about-story" class="py-20 bg-base-100">
    <div class="container mx-auto px-4 text-center">
      <h2 class="text-4xl font-semibold mb-6 text-primary">
        {{ $t("aboutPage.story.heading") }}
      </h2>
      <p class="max-w-2xl mx-auto text-base-content/80 mb-10">
        {{ $t("aboutPage.story.description") }}
      </p>

      <div class="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-6 text-left max-w-4xl mx-auto">
        <div>
          <h3 class="font-bold text-lg">{{ $t("aboutPage.story.cards.experience.title") }}</h3>
          <p>{{ $t("aboutPage.story.cards.experience.body") }}</p>
        </div>
        <div>
          <h3 class="font-bold text-lg">{{ $t("aboutPage.story.cards.clients.title") }}</h3>
          <p>{{ $t("aboutPage.story.cards.clients.body") }}</p>
        </div>
        <div>
          <h3 class="font-bold text-lg">{{ $t("aboutPage.story.cards.focus.title") }}</h3>
          <p>{{ $t("aboutPage.story.cards.focus.body") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
